module.exports = __webpack_public_path__ + "static/media/loader_gif.beed19ef.gif";